import script from "./whDOnceImg2_t3A.vue?vue&type=script&setup=true&lang=js"
export * from "./whDOnceImg2_t3A.vue?vue&type=script&setup=true&lang=js"

import "./whDOnceImg2_t3A.vue?vue&type=style&index=0&id=63805b2c&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63805b2c"]])

export default __exports__